module.exports = __webpack_public_path__ + "bed-button-invite.0a9d85d9.png";